angular.module('content.widgets.DefaultWidgetController', [
  'content.widgets.DefaultWidgetService'
])

/**
 * The DefaultWidgetController manages scope logic and user
 * interaction.
 *
 * @class DefaultWidgetController
 * @constructor
 * @module content.widgets.DefaultWidgetController
 **/
.controller('DefaultWidgetController', [
  '$scope',
  'DefaultWidgetService',
  function ($scope, DefaultWidgetService) {
    'use strict';

    $scope.formattedModel = {};

    $scope.state = {
      selected: null,
      breadcrumbs: [],
      list: [],
      media: []
    };

    $scope.getModel = function getModel() {
      return DefaultWidgetService.getModel($scope.model);
    };

    /**
     * Method executes the initialization process.
     *
     * @private
     */
    function initialize() {
      // emits an event passing the current scope.  This scope is picked up by the
      // associated theme to register as the active scope.
      // This event is required to initialize a widget
      $scope.$emit('setCurrentContentScope', $scope);
    }

    initialize();
  }
]);
